// Add project specific javascript code and import of additional bundles here:
import fieldRegistry from 'sulu-admin-bundle/containers/Form/registries/fieldRegistry';
import viewRegistry from 'sulu-admin-bundle/containers/ViewRenderer/registries/viewRegistry';
import HelpLink from './fields/HelpLink';
import Preview from './views/Preview/Preview';
import {initializer} from 'sulu-admin-bundle/services';
import formToolbarActionRegistry from 'sulu-admin-bundle/views/Form/registries/formToolbarActionRegistry';
import FixedSetUnpublishedToolbarAction from './toolbarActions/SetUnpublishedToolbarAction';

fieldRegistry.add('help_link', HelpLink);
viewRegistry.add('app.preview', Preview);

// Override the default SetUnpublishedToolbarAction which lacks error handling (no .catch() on the
// unpublish request), causing the confirmation dialog to remain stuck in loading state on server errors.
initializer.addUpdateConfigHook('sulu_admin', (config, initialized) => {
    if (!initialized) {
        formToolbarActionRegistry.toolbarActions['sulu_admin.set_unpublished'] = FixedSetUnpublishedToolbarAction;
    }
});